export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validationRut = (rut: string): boolean => {
  if (rut) {
    const cleanRut = rut.replace(/\./g, "").replace(/-/g, "");
    if (!/^\d{7,8}[0-9kK]$/.test(cleanRut)) return false;

    const body = cleanRut.slice(0, -1);
    const dv = cleanRut.slice(-1).toUpperCase();

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body[i]) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const expectedDv = 11 - (sum % 11);
    const computedDv =
      expectedDv === 11 ? "0" : expectedDv === 10 ? "K" : expectedDv.toString();

    return dv === computedDv;
  }
  return false;
};

export const validatePasswords = (
  password: string,
  confirmPassword: string,
  useRandom: boolean
): string => {
  if (useRandom) return "";
  if (!password) return "La contraseña es obligatoria";
  return password === confirmPassword ? "" : "Las contraseñas no coinciden";
};

export const generatePassword = (): string => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
  let randomPassword = "";
  for (let i = 0; i < 12; i++) {
    randomPassword += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return randomPassword;
};
